import { useEffect, useState } from "react";
import { useProgressActive } from "../lib/progress";

/**
 * Linha fina de carregamento na base da barra superior. Aparece só se a espera passar de 180 ms (navegação rápida não
 * pisca) e some com esmaecimento. Puramente visual: o "Carregando" para leitores de tela fica nos esqueletos.
 */
export function TopProgress() {
  const active = useProgressActive();
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!active) {
      setShown(false);
      return;
    }
    const t = window.setTimeout(() => setShown(true), 180);
    return () => window.clearTimeout(t);
  }, [active]);
  return <div className="vx-progress" data-active={shown ? "" : undefined} aria-hidden="true" />;
}
